import React, { useEffect, useState } from "react"
import { SubmitButton, LinkButton, Submit, EditButton } from "../../components/button/buttons";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form, useField } from 'formik';
import { logOut, enrollSecondFactor, complete2FAEnrollment, enableRecaptcha } from "../../authActions/authActions";
import { TextInput } from "../../components/input/inputs";
import styles from "./mfa.module.css"
import en from 'react-phone-number-input/locale/en'
import CountryCode  from "../../components/dropDown/CountryCode"
import { EMAIL_SIGN_IN_ERROR_MESSAGES, SIGN_IN_ERROR_MESSAGES } from "../../authActions/constants";
import { getCountryCallingCode } from 'react-phone-number-input/input'
import IMAGES from "../../assets/images/images";
import SecondaryTooltip from "../../components/secondaryToolTip/secondaryToolTip";
import { getAuth } from "firebase/auth";
import { app } from "../../configuration/gcp-identity-platform-config";
import { updateMfaType } from "../../api/userManagement/mfa.service";
import Asterisk from "../../components/asterisk/Asterisk";


let obj = {
    width: 210,
    marginTop:5,
    marginRight:10
}
const FieldWrapper = ({ children }) => {
    return <div className={styles.fieldContainer}>{children}</div>;
};

const TwoFactorAuth = ({ onSendOTP,isSubmitSendOTP }) => {
    
    const [phone, setPhone] = useState("")
    const [code, setCode] = useState("")
    const [country, setCountry] = useState()
    //enableRecaptcha()
    return (
        <div className={styles.mfaContainer}>
            <h2 className={styles.title}>Enable Two Factor Authentication</h2>
            {/* <label>You need to enable Two-Factor authentication before you can access the Admin Portal</label> */}
            <span className={styles.description}>For security purposes, we have implemented two factor authentication to login to the IPX portal.</span>

            <span className={styles.description}>Please provide your phone number below, and we will send a verification code to your phone via SMS.</span>
            <div className={styles.phoneContainer}>
            <CountryCode
            id="countryCode"
            className={styles.countryCode}
            labels={en}
            value={country}
            onChange={setCountry}/>
                <TextInput
                    label="Number"
                    name="phone"
                    type="number"
                    style={styles.phoneInput}
                    placeholder="Enter mobile number"
                    onChange={(event) => {
                        setPhone(event.target.value)
                    }}
                />               
            </div>
            <span className={styles.message}>Do not prefix a 0 before the mobile number.</span>
            <Submit                  
                style={styles.submit}
                title={"Send Code"}
                isSubmitting={isSubmitSendOTP}                
                disabled={(!country || phone.trim().length ==0)}  // || phone.toString().length < 10 || phone.toString().length > 15
                onClick={() => {
                   let _countryCode = `+${getCountryCallingCode(country)}`; //CUP-667
                    onSendOTP(`${_countryCode}${phone}`)
                }} />
        </div>
    );
}

const OTPVerification = ({ onPhoneReset, phone, onVerify,isSubmitVerifyOTP }) => {
    const [otp, setOTP] = useState("")
    const [deviceName, setDeviceName] = useState("My Phone")
    return (
        <div className={styles.mfaContainer}>
            <div className={styles.smsTitle}>Verification Code</div>
            <span className={styles.smsdescription}>{`A verification code has been sent to the mobile number you provided.`}</span>
            {/* <label>You need to enable Two-Factor authentication before you can access the Admin Portal</label> */}
            {/* <span className={styles.smsdescription}>{`An authentication code has been sent via SMS on ${phone}.`}</span> */}

            {/* <span className={styles.description2}>You will receive this via SMS.</span> */}
            <div className={styles.otpContainer}>
                <label className={styles.smslabel}>Verification Code<Asterisk/></label>
                <input
                    className={styles.otpInput}
                    type={"number"}
                    placeholder="Enter verification code"
                    onChange={(event) => {
                        setOTP(event.target.value)
                    }} />
                <label className={styles.smslabel}>Device Name</label>
                <input
                    className={styles.otpInput}
                    placeholder="Enter your device name, eg. My iPhone 14"
                    onChange={(event) => {
                        setDeviceName(event.target.value)
                    }} />
            </div>
            {/*<SubmitButton
                onClick={() => {
                    onVerify(otp, deviceName)

                }}>Verify</SubmitButton>*/}
                <div className={styles.smsfooter}>
                  <EditButton className={styles.backButton} title={"Back"} style={styles.btn} onClick={onPhoneReset}/>
                  <Submit style={styles.submit} title="Verify" isSubmitting={isSubmitVerifyOTP} disabled={(!otp)} onClick={() => {onVerify(otp, deviceName)}}/>
                </div>
                {/* <div className={styles.note}>Note: Authentication method cannot be changed later.</div> */}
            {/* <Submit                  
                style={styles.submit}
                title={"Verify"}
                isSubmitting={isSubmitVerifyOTP}                
                disabled={(!otp)} 
                onClick={() => {
                    onVerify(otp, deviceName)
                }}
            /> */}
            {/* <LinkButton
                title={"Incorrect phone number? Click here to re-enter."}
                onClick={onPhoneReset} /> */}
        </div>
    );
}

const EmailOTPVerification = ({ userDetails, isSubmitVerifyOTP, onPhoneReset,onVerifyEmail, }) => {
    const [otp, setOTP] = useState("")
    return (
        <div className={styles.mfaContainer}>
            <div className={styles.smsTitle}>Verification Code</div>
            <span className={styles.smsdescription}>{`A verification code has been sent to your registered email address.`}</span>
            <div className={styles.otpContainer}>
                <label className={styles.smslabel}>Verification Code<Asterisk/></label>
                <input
                    className={styles.otpInput}
                    type={"number"}
                    placeholder="Enter verification code"
                    onChange={(event) => {
                        setOTP(event.target.value)
                    }} />
                <div className={styles.otpnote}>The verification code will remain valid for the next 5 minutes.</div>
            </div>
                <div className={styles.smsfooter}>
                  <EditButton className={styles.backButton} title={"Back"} style={styles.btn} onClick={onPhoneReset}/>
                  <Submit style={styles.submit} title="Verify" isSubmitting={isSubmitVerifyOTP} disabled={(!otp)}onClick={() => {onVerifyEmail(otp)}}/>
                </div>
                {/* <div className={styles.note}>Note: Authentication method cannot be changed later.</div> */}
        </div>
    );
}
const EnableAuth = ({ onSendOTP, isSubmitSendOTP, userDetails, onSendEmailOTP,previousSelectionType }) => {
    const OPTIONS = { SMS: "sms", EMAIL: "email" };
    const signInWithDifferentUser = () => {
        logOut();
    };

    return (
        <div className={styles.enablemfaContainer}>
            <div className={styles.mfatitle}>Setup Two-Factor Authentication(2FA)</div>
            <span className={styles.mfadescription}>We have implemented Two-Factor Authentication for logging into the IPXplore Portal.</span>
            <Formik
                initialValues={{ selectionType:'email', phone: '', country: '' }}
                onSubmit={(values) => {
                    if (values.selectionType === OPTIONS.SMS) {
                        let _countryCode = `+${getCountryCallingCode(values.country)}`;
                        onSendOTP(`${_countryCode}${values.phone}`);
                    } else {
                        onSendEmailOTP()
                    }
                }}
            >
                {({ values, handleChange, setFieldValue }) => (
                    <Form>
                        <div className={styles.bottomcont}>
                        {/* <div className={styles.subheading}>Please choose your preferred method for 2FA setup, to receive your verification code.</div> */}
                            {/* <div className={styles.subheading}>Please <span className={styles.boldheader}>select any one method</span> you prefer.</div> */}
                            {/* <div className={styles.radioContainer}>
                                <div className={styles.radiochild}>
                                <label className={styles.radioDiv}>
                                    <Field
                                        className={styles.radioDiv}
                                        type="radio"
                                        name="selectionType"
                                        value={OPTIONS.SMS}
                                        onChange={handleChange}
                                    />
                                    <span className={styles.radiotext}>Mobile Number</span>
                                </label>
                                </div>
                                <div className={styles.radiochild}>
                                <label className={styles.radioDiv}>
                                    <Field
                                        className={styles.radioDiv}
                                        type="radio"
                                        name="selectionType"
                                        value={OPTIONS.EMAIL}
                                        onChange={handleChange}
                                    />
                                    <span className={styles.radiotext}>Email Address</span>
                                </label>
                                </div>
                            </div> */}
                            {/* <div className={styles.note}>Once preferred method is chosen, you will receive a <span className={styles.boldheader}>Verification Code</span> via the chosen method every time you log into the portal.</div> */}
                            {/* <div className={styles.note}>Note: Authentication method cannot be changed later.</div> */}
                            {values.selectionType === OPTIONS.SMS && (
                                <div className={styles.mfaContain}>
                                    <div className={styles.phoneContainer}>
                                        <div className={styles.parentlabels}>
                                            <label className={styles.countrylabel}>Country</label>
                                            <label className={styles.phonelabel}>Mobile Number</label>
                                        </div>
                                        <div className={styles.mobparent}>
                                            <CountryCode
                                                id="countryCode"
                                                className={styles.countryCode}
                                                labels={en}
                                                value={values.country}
                                                onChange={(value) => setFieldValue('country', value)}
                                            />
                                            <Field
                                                as={TextInput}
                                                label="Number"
                                                name="phone"
                                                type="number"
                                                placeholder="Enter mobile number"
                                                onChange={(event) => setFieldValue('phone', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <span className={styles.message}>Please make sure to enter your mobile numbers without any leading 0s.</span>
                                </div>
                            )}
                            {values.selectionType === OPTIONS.EMAIL && (
                                <>
                                    <div className={styles.emailsection}>
                                    The code will be sent to your registered email address <span className={styles.boldheader}>{userDetails?.currentUser?.email}</span>
                                        {/* Your Registered Email Address */}
                                        {/* <SecondaryTooltip text={"Code will be sent to your registered email address"} positions={['bottom', 'right']}>
                                            <img className={styles.circleinfo} src={IMAGES.infoCircle} />
                                        </SecondaryTooltip> */}
                                    </div>
                                    {/* <div className={styles.useremail}>{userDetails?.currentUser?.email}</div> */}
                                </>
                            )}
                        </div>
                        {(values.selectionType === OPTIONS.SMS || values.selectionType === OPTIONS.EMAIL) && (
                            <>
                            <div className={styles.commonsection}>To set up Two-Factor Authentication, please click the <span className={styles.boldheader}>Send Code</span> button.</div>
                            <div className={styles.enablefooter}>
                                <EditButton
                                    className={styles.backButton}
                                    title="Cancel"
                                    style={styles.btn}
                                    onClick={signInWithDifferentUser}
                                />
                                <Submit
                                    style={styles.submit}
                                    title="Send Code"
                                    isSubmitting={isSubmitSendOTP}
                                    disabled={values.selectionType === OPTIONS.SMS && (!values.country || (values.phone || '').trim().length === 0)}
                                />
                            </div>
                            </>
                        )}
                    </Form>
                )}
            </Formik>
        </div>
    );
};


const MultifactorEnabler = (props) => {
    const [detailsCaptured, setDetailsCaptured] = useState("")
    const [phone, setPhone] = useState("")
    const [verificationId, setVerificationId] = useState("");
    const [isSubmitSendOTP,setIsSubmitSendOTP]=useState(false);
    const [isSubmitVerifyOTP,setIsSubmitVerifyOTP]=useState(false);
    const [previousSelectionType, setPreviousSelectionType] = useState("")
    const userDetails = getAuth(app);

    useEffect(() => {
        return () => {
            window.recaptchaVerifier2FA = undefined;
        };
      }, []);

    const onSendOTP = (phone) => {
        setPhone(phone)
        setIsSubmitSendOTP(true);
        enrollSecondFactor(phone).then((verifyId) => {
            setVerificationId(verifyId)
            setDetailsCaptured("sms");
            setIsSubmitSendOTP(false);
        }).catch((error) => {
            setIsSubmitSendOTP(false);
            setVerificationId("")
            setDetailsCaptured("");
            console.log("error code",error.code)
            console.log("error", error);
            if (error.code === "auth/invalid-phone-number") {
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.INVALID_PHONE_NUMBER});
            } else if (error.code === "auth/too-many-requests") {
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.TOO_MANY_REQUEST});
            } else if (error.code === "second-factor-already-in-use") {
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.ALREADY_2FA_ENROLLED});
            }else if(error.code==="auth/requires-recent-login"){
              props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.REQUIRES_RECENT_LOGIN});
                logOut();
            }else if(error.code==="auth/invalid-app-credential"){
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.INVALID_APP_CREDENTIALS});
            }else if(error.code==="auth/internal-error-encountered."){
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.INTERNAL_ERROR});
            }else {
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.RECAPTCHA_ISSUE});
            }
        })
    }

    const onSendEmailOTP = () =>{
        setIsSubmitSendOTP(true);
        props.sendEmailotp().then((res) => {
            if(res.status){
                setDetailsCaptured("email");
                setIsSubmitSendOTP(false);
            }else{
                if(res.error=="MFA_ALREADY_SET"){
                   props.showAlertPopup({alertHeader:"Alert"},{alertMessage:'MFA is already set for this user.Please login again'});
                    logOut();
                }if(res.error=='429'){
                    props.showAlertPopup({alertHeader:"Alert"},{alertMessage:EMAIL_SIGN_IN_ERROR_MESSAGES.TOO_MANY_REQUEST});
                }else{
                  props.showAlertPopup({alertHeader:"Alert"},{alertMessage:'We encountered an issue while sending the verification code to your preferred method. Please try again'});
                }
                setIsSubmitSendOTP(false);
                setVerificationId("")
                setDetailsCaptured("");
            }
        }).catch((error) => {
            setIsSubmitSendOTP(false);
            setVerificationId("")
            setDetailsCaptured("");
            console.log("error", error);
        })
    }

    const onVerifyOtp = async (otp, deviceName) => {
        try {
            setIsSubmitVerifyOTP(true);
            const result = await complete2FAEnrollment(verificationId, otp, deviceName)
            // let obj = {mfaType:"sms"}
            // const updateResponse = await updateMfaType(obj);
            setIsSubmitVerifyOTP(false);
            logOut()
                .then((res) => {
                    navigate("/login");
                    //TBD
                  props.showAlertPopup({alertHeader:"Alert"},{alertMessage:'The verification code has been successfully verified. Please log in to continue.'});
                    /*setTimeout(() => {
                        window.location.reload();
                    }, 6000)*/
                })
                .catch((error) => {
                });
        } catch (error) {
            console.log("error",error);
            setIsSubmitVerifyOTP(false);
            if(error.code="auth/invalid-verification-code"){
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.INVALID_VERIFICATION_CODE});
            }else if (error.code === "auth/missing-verification-id") {
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.RECAPTCHA_ISSUE});
            }else{
               props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.RECAPTCHA_ISSUE});
            }
        }
    }

    const onVerifyEmailOtp = async (otp) => {
        setIsSubmitVerifyOTP(true);
        let emailOtp = { otp: otp };
        try {
          const result = await props.varifyEmailOTP(emailOtp);
          if (result?.res?.success) {
            // let obj = { mfaType: "email" };
            // const updateResponse = await updateMfaType(obj);
            setIsSubmitVerifyOTP(false);
            logOut()
            .then((res)=>{
                navigate("/login");
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:'The verification code has been successfully verified. Please log in to continue.'});
            }).catch((error) => {
            });
          } else {
            setIsSubmitVerifyOTP(false);
            if (result?.code === "INCORRECT_OTP") {
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.INVALID_VERIFICATION_CODE});
            } else if (result?.code === "OTP_EXPIRED") {
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.EXPIRE_VERIFICATION_CODE});
            }else if(result?.code == '429'){
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:EMAIL_SIGN_IN_ERROR_MESSAGES.TOO_MANY_REQUEST});
            }else{
                props.showAlertPopup({alertHeader:"Alert"},{alertMessage:EMAIL_SIGN_IN_ERROR_MESSAGES.SERVER_ISSUE});
            }
          }
        } catch (error) {
          console.log("error", error);
          setIsSubmitVerifyOTP(false);
        }
      };
      

    const signInWithDifferentUser = () => {
        logOut();
           
    }

    const navigate = useNavigate();
    return (
        <div className={styles.root}>
            <div className={`${(detailsCaptured==="sms"||detailsCaptured==="email")?styles.containers:styles.container}`}>
            <div id="captcha-container-2fa"></div>
                {
                    detailsCaptured==="sms" ?
                        <OTPVerification
                            phone={phone}
                            onPhoneReset={() => {
                                setDetailsCaptured("")
                                setPreviousSelectionType("sms")
                            }}
                            onVerify={onVerifyOtp} isSubmitVerifyOTP={isSubmitVerifyOTP}/>
                        :detailsCaptured==="email"?<EmailOTPVerification userDetails={userDetails} isSubmitVerifyOTP={isSubmitVerifyOTP} onPhoneReset={() => {setDetailsCaptured(""); setPreviousSelectionType("email")}} onVerifyEmail={onVerifyEmailOtp}/>:
                        // <TwoFactorAuth
                        //     onSendOTP={onSendOTP} isSubmitSendOTP={isSubmitSendOTP}/>
                        <EnableAuth onSendOTP={onSendOTP} isSubmitSendOTP={isSubmitSendOTP} userDetails={userDetails} onSendEmailOTP={onSendEmailOTP} previousSelectionType={previousSelectionType}/>
                }
                {/* <LinkButton className={styles.resetLink}
                    title={"Click here to sign in with a different user"}
                    onClick={signInWithDifferentUser}
                /> */}
            </div>
        </div>
    );
}

export default MultifactorEnabler;